var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetSeverity24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.436 17.38 13.569 4.81a1.776 1.776 0 0 0-3.138 0L3.565 17.38c-.674 1.232.193 2.754 1.568 2.754h13.734c1.375 0 2.242-1.522 1.569-2.754ZM14.728 4.14a3.088 3.088 0 0 0-5.456 0L2.405 16.71c-1.17 2.143.336 4.789 2.728 4.789h13.734c2.392 0 3.899-2.646 2.728-4.79L14.728 4.142Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.114 9.854c0-.502.397-.91.885-.91.49 0 .885.408.885.91v3.894c0 .503-.396.91-.885.91a.897.897 0 0 1-.885-.91V9.854Zm1.783 6.712a.91.91 0 0 1-.897.921.91.91 0 0 1-.897-.921.91.91 0 0 1 .897-.922.91.91 0 0 1 .897.922Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetSeverity24);
export default __webpack_public_path__ + "static/media/set_severity_24.0bb51d6a138df193e844d008a1d77401.svg";
export { ForwardRef as ReactComponent };